export default function capitalize(str) {
  if (typeof str !== 'string') {
    return str;
  }
  const ret = str.charAt(0).toUpperCase() + str.slice(1);
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/capitalize.js
// module id = 3696
// module chunks = 0